module.exports = __webpack_public_path__ + "static/media/fav.a3615b8d.svg";